/**
 * @author        luis.orihuela@agileengine.com (Luis Orihuela)
 * @copyright     Copyright (c) 2017, Zumper
 * @description   MapTools
 */

import React, { type ReactNode } from 'react'

export interface MapToolsProps {
  topLeft?: ReactNode
  topRight?: ReactNode
  bottomLeft?: ReactNode
  bottomRight?: ReactNode
}

export const MapTools = ({ topLeft, topRight, bottomLeft, bottomRight }: MapToolsProps) => {
  return (
    <>
      {topLeft ? <div className="absolute top-[18px] left-[23px] z-[5]">{topLeft}</div> : null}
      {topRight ? <div className="absolute top-[18px] right-[20px] z-[4]">{topRight}</div> : null}
      {bottomLeft ? (
        <div className="absolute bottom-[46px] left-[20px] z-[4]">{bottomLeft}</div>
      ) : null}
      {bottomRight ? (
        <div className="absolute bottom-[30px] right-[20px] z-[4]">{bottomRight}</div>
      ) : null}
    </>
  )
}
